import { useEffect } from 'react';
import { useAppDispatch } from '../../../../../app/hooks';
import { ensureReconciliations } from '../../../../../store/reconciliations/reconciliationsSlice';
import { fyKey } from '../../../../../store/reconciliations/constants';

/**
 * Dispatches `ensureReconciliations` for one company / FY-set. Safe to call from the chip AND
 * every pill on the same render — the reducer's own claim (loading + token) is the de-dup point
 * (D26-7), not this hook, so calling it from multiple mounted places never issues extra fetches.
 */
export function useEnsureReconciliations(orgId: string | undefined, fys: number[] | null): void {
    const dispatch = useAppDispatch();
    const key = fyKey(fys);

    useEffect(() => {
        if (!orgId) return;
        dispatch(ensureReconciliations({ orgId, fys }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, orgId, key]);
}
